import * as React from 'react';

const FlagReportSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fillRule="evenodd">
            <path
                d="M6 5.342v6.256l9.731-3.349L6 5.342zM6 4.3l13 3.883-13 4.474V21h1v1H4v-1h1V2h1v2.299z"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

FlagReportSvg.displayName = 'FlagReportSvg';
export default FlagReportSvg;
